export class HighImpactCommission {
	public contractId: string;
	public supplierId: string;
	public contractNum: string;
	public supplierName: string;
	public parentName: string;
	public agentName: string;
	public contactName: string;
	public commissionTypeName: string;
	public amount: number;
	public utilityAccountNumList: string;
	public dbaName: string;
	public commodity: string;

	constructor(highImpactCommission?: HighImpactCommission) {
		Object.assign(this, highImpactCommission);
	}
}
